import React, { Dispatch, SetStateAction, useCallback } from "react";
import { UploadIcon } from "@heroicons/react/outline";
import { CloudUpload } from "@mui/icons-material";
import { useApi } from "../../contexts/ApiContext";

type Props = {
  iconSrc?: string;
  isLoading: boolean;
  setIsLoading: Dispatch<SetStateAction<boolean>>
  onSelectImage?: () => void;
  onSelectIcon?: () => void;
  mediaFile?: File
};

const VideoSelector = React.memo(
  ({ iconSrc, isLoading, setIsLoading, onSelectImage, onSelectIcon, mediaFile }: Props) => {


    const onIconClick = useCallback(
      async (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        event.stopPropagation();
        onSelectIcon && await onSelectIcon();
      },
      [onSelectIcon]
    );

    return (
      <div className="w-full">
        <div
          className="w-full flex flex-col  items-center justify-center cursor-pointer border-dashed border-gray-50 border rounded-md bg-kyzzen-secondary right-10 top-4 bg-full"
          role="button"
          style={(
            iconSrc?.toLowerCase().includes('image') || (
              iconSrc?.toLowerCase().includes('.png') ||
              iconSrc?.toLowerCase().includes('.jpg') ||
              iconSrc?.toLowerCase().includes('.jpeg') ||
              iconSrc?.toLowerCase().includes('.gif'))
          ) ? {
            backgroundImage: `url('${iconSrc}')`,
            backgroundPosition: `center`,
            backgroundSize: `cover`,
            minHeight: '350px',
            height: '350px'
          } : {}}
          onClick={onIconClick}
        >
          {!iconSrc && (
            <div className="flex flex-col items-center justify-center" style={{height:'350px'}}>
              <div className="rounded-full p-3 block mb-4 bg-gray-80 w-fit ">
                <span className="rounded-full p-2 block bg-gray-60 w-fit">
                  <CloudUpload className="h-12 w-12 text-gray-50" />
                </span>
              </div>
              <div className="text-sm text-gray-30">
                <span className="text-blue mb-2 block">{isLoading ? 'Loading Media...' : 'Click to upload'}</span>
              </div>
              <div className="text-sm text-gray-30 ">
                MP4, OGG, MOV, PNG, JPG, GIF
              </div>
            </div>
          )}
          {(iconSrc && (
            iconSrc?.includes('video') ||
            (iconSrc?.includes('.mp4') ||
              iconSrc?.includes('.mov') ||
              iconSrc?.includes('.ogg'))
          )) && (
              <div>
                {
                  iconSrc.includes('youtube') ?
                    <iframe className="w-full h-full" src={iconSrc} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen /> :
                    <video controls id="video-tag">
                      <source id="video-source" src={iconSrc} />
                      Your browser does not support the video tag.
                    </video>
                }
              </div>
            )


          }
        </div>
      </div>
    );
  }
);

export default VideoSelector;
